import type { ErrorType } from '../../shared/lib/axios/client'
import type {
  AcceptInvitationDto,
  InviteUserDto,
  PaginatedUsersDto,
  PasswordlessUserDto,
  UserControllerAcceptExistingUserInvitationParams,
  UserControllerFindAllParams,
  UserControllerVerifyInvitationV2Params,
  VerifyInvitationResponseDto,
} from '.././types'
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'

/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Detelio API specification
 * openAPI specification for Detelio API
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query'

import { axiosClient } from '../../shared/lib/axios/client'

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

export const userControllerFindById = (
  id: string,
  options?: SecondParameter<typeof axiosClient>,
  signal?: AbortSignal,
) => {
  return axiosClient<PasswordlessUserDto>(
    { url: `https://test-api.detelio.ai/user/${id}`, method: 'GET', signal },
    options,
  )
}

export const getUserControllerFindByIdQueryKey = (id?: string) => {
  return [`https://test-api.detelio.ai/user/${id}`] as const
}

export const getUserControllerFindByIdQueryOptions = <
  TData = Awaited<ReturnType<typeof userControllerFindById>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerFindById>>, TError, TData>>
    request?: SecondParameter<typeof axiosClient>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getUserControllerFindByIdQueryKey(id)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerFindById>>> = ({ signal }) =>
    userControllerFindById(id, requestOptions, signal)

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof userControllerFindById>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserControllerFindByIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof userControllerFindById>>
>
export type UserControllerFindByIdQueryError = ErrorType<unknown>

export function useUserControllerFindById<
  TData = Awaited<ReturnType<typeof userControllerFindById>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerFindById>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerFindById>>,
          TError,
          Awaited<ReturnType<typeof userControllerFindById>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerFindById<
  TData = Awaited<ReturnType<typeof userControllerFindById>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerFindById>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerFindById>>,
          TError,
          Awaited<ReturnType<typeof userControllerFindById>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerFindById<
  TData = Awaited<ReturnType<typeof userControllerFindById>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerFindById>>, TError, TData>>
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserControllerFindById<
  TData = Awaited<ReturnType<typeof userControllerFindById>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerFindById>>, TError, TData>>
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getUserControllerFindByIdQueryOptions(id, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const userControllerFindAll = (
  params?: UserControllerFindAllParams,
  options?: SecondParameter<typeof axiosClient>,
  signal?: AbortSignal,
) => {
  return axiosClient<PaginatedUsersDto>(
    { url: `https://test-api.detelio.ai/user`, method: 'GET', params, signal },
    options,
  )
}

export const getUserControllerFindAllQueryKey = (params?: UserControllerFindAllParams) => {
  return [`https://test-api.detelio.ai/user`, ...(params ? [params] : [])] as const
}

export const getUserControllerFindAllQueryOptions = <
  TData = Awaited<ReturnType<typeof userControllerFindAll>>,
  TError = ErrorType<unknown>,
>(
  params?: UserControllerFindAllParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerFindAll>>, TError, TData>>
    request?: SecondParameter<typeof axiosClient>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getUserControllerFindAllQueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerFindAll>>> = ({ signal }) =>
    userControllerFindAll(params, requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof userControllerFindAll>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserControllerFindAllQueryResult = NonNullable<Awaited<ReturnType<typeof userControllerFindAll>>>
export type UserControllerFindAllQueryError = ErrorType<unknown>

export function useUserControllerFindAll<
  TData = Awaited<ReturnType<typeof userControllerFindAll>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | UserControllerFindAllParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerFindAll>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof userControllerFindAll>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerFindAll<
  TData = Awaited<ReturnType<typeof userControllerFindAll>>,
  TError = ErrorType<unknown>,
>(
  params?: UserControllerFindAllParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerFindAll>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerFindAll>>,
          TError,
          Awaited<ReturnType<typeof userControllerFindAll>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerFindAll<
  TData = Awaited<ReturnType<typeof userControllerFindAll>>,
  TError = ErrorType<unknown>,
>(
  params?: UserControllerFindAllParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerFindAll>>, TError, TData>>
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserControllerFindAll<
  TData = Awaited<ReturnType<typeof userControllerFindAll>>,
  TError = ErrorType<unknown>,
>(
  params?: UserControllerFindAllParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerFindAll>>, TError, TData>>
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getUserControllerFindAllQueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const userControllerFindSelfUser = (
  options?: SecondParameter<typeof axiosClient>,
  signal?: AbortSignal,
) => {
  return axiosClient<PasswordlessUserDto>(
    { url: `https://test-api.detelio.ai/user/self/details`, method: 'GET', signal },
    options,
  )
}

export const getUserControllerFindSelfUserQueryKey = () => {
  return [`https://test-api.detelio.ai/user/self/details`] as const
}

export const getUserControllerFindSelfUserQueryOptions = <
  TData = Awaited<ReturnType<typeof userControllerFindSelfUser>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerFindSelfUser>>, TError, TData>>
  request?: SecondParameter<typeof axiosClient>
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getUserControllerFindSelfUserQueryKey()

  const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerFindSelfUser>>> = ({ signal }) =>
    userControllerFindSelfUser(requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof userControllerFindSelfUser>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserControllerFindSelfUserQueryResult = NonNullable<
  Awaited<ReturnType<typeof userControllerFindSelfUser>>
>
export type UserControllerFindSelfUserQueryError = ErrorType<unknown>

export function useUserControllerFindSelfUser<
  TData = Awaited<ReturnType<typeof userControllerFindSelfUser>>,
  TError = ErrorType<unknown>,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerFindSelfUser>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerFindSelfUser>>,
          TError,
          Awaited<ReturnType<typeof userControllerFindSelfUser>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerFindSelfUser<
  TData = Awaited<ReturnType<typeof userControllerFindSelfUser>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerFindSelfUser>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerFindSelfUser>>,
          TError,
          Awaited<ReturnType<typeof userControllerFindSelfUser>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerFindSelfUser<
  TData = Awaited<ReturnType<typeof userControllerFindSelfUser>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerFindSelfUser>>, TError, TData>>
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserControllerFindSelfUser<
  TData = Awaited<ReturnType<typeof userControllerFindSelfUser>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof userControllerFindSelfUser>>, TError, TData>>
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getUserControllerFindSelfUserQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const userControllerDeactivateUser = (
  userId: string,
  options?: SecondParameter<typeof axiosClient>,
) => {
  return axiosClient<void>(
    { url: `https://test-api.detelio.ai/user/deactivate/${userId}`, method: 'PATCH' },
    options,
  )
}

export const getUserControllerDeactivateUserMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userControllerDeactivateUser>>,
    TError,
    { userId: string },
    TContext
  >
  request?: SecondParameter<typeof axiosClient>
}): UseMutationOptions<
  Awaited<ReturnType<typeof userControllerDeactivateUser>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationKey = ['userControllerDeactivateUser']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userControllerDeactivateUser>>,
    { userId: string }
  > = (props) => {
    const { userId } = props ?? {}

    return userControllerDeactivateUser(userId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type UserControllerDeactivateUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof userControllerDeactivateUser>>
>

export type UserControllerDeactivateUserMutationError = ErrorType<unknown>

export const useUserControllerDeactivateUser = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof userControllerDeactivateUser>>,
      TError,
      { userId: string },
      TContext
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof userControllerDeactivateUser>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationOptions = getUserControllerDeactivateUserMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
export const userControllerActivateUser = (userId: string, options?: SecondParameter<typeof axiosClient>) => {
  return axiosClient<void>(
    { url: `https://test-api.detelio.ai/user/activate/${userId}`, method: 'PATCH' },
    options,
  )
}

export const getUserControllerActivateUserMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userControllerActivateUser>>,
    TError,
    { userId: string },
    TContext
  >
  request?: SecondParameter<typeof axiosClient>
}): UseMutationOptions<
  Awaited<ReturnType<typeof userControllerActivateUser>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationKey = ['userControllerActivateUser']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userControllerActivateUser>>,
    { userId: string }
  > = (props) => {
    const { userId } = props ?? {}

    return userControllerActivateUser(userId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type UserControllerActivateUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof userControllerActivateUser>>
>

export type UserControllerActivateUserMutationError = ErrorType<unknown>

export const useUserControllerActivateUser = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof userControllerActivateUser>>,
      TError,
      { userId: string },
      TContext
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof userControllerActivateUser>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationOptions = getUserControllerActivateUserMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
export const userControllerInviteUser = (
  inviteUserDto: InviteUserDto,
  options?: SecondParameter<typeof axiosClient>,
  signal?: AbortSignal,
) => {
  return axiosClient<void>(
    {
      url: `https://test-api.detelio.ai/user/invite`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: inviteUserDto,
      signal,
    },
    options,
  )
}

export const getUserControllerInviteUserMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userControllerInviteUser>>,
    TError,
    { data: InviteUserDto },
    TContext
  >
  request?: SecondParameter<typeof axiosClient>
}): UseMutationOptions<
  Awaited<ReturnType<typeof userControllerInviteUser>>,
  TError,
  { data: InviteUserDto },
  TContext
> => {
  const mutationKey = ['userControllerInviteUser']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userControllerInviteUser>>,
    { data: InviteUserDto }
  > = (props) => {
    const { data } = props ?? {}

    return userControllerInviteUser(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type UserControllerInviteUserMutationResult = NonNullable<
  Awaited<ReturnType<typeof userControllerInviteUser>>
>
export type UserControllerInviteUserMutationBody = InviteUserDto
export type UserControllerInviteUserMutationError = ErrorType<unknown>

export const useUserControllerInviteUser = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof userControllerInviteUser>>,
      TError,
      { data: InviteUserDto },
      TContext
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof userControllerInviteUser>>,
  TError,
  { data: InviteUserDto },
  TContext
> => {
  const mutationOptions = getUserControllerInviteUserMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
export const userControllerResendInvitation = (
  inviteeId: string,
  options?: SecondParameter<typeof axiosClient>,
) => {
  return axiosClient<void>(
    { url: `https://test-api.detelio.ai/user/invite/resend/${inviteeId}`, method: 'PATCH' },
    options,
  )
}

export const getUserControllerResendInvitationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userControllerResendInvitation>>,
    TError,
    { inviteeId: string },
    TContext
  >
  request?: SecondParameter<typeof axiosClient>
}): UseMutationOptions<
  Awaited<ReturnType<typeof userControllerResendInvitation>>,
  TError,
  { inviteeId: string },
  TContext
> => {
  const mutationKey = ['userControllerResendInvitation']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userControllerResendInvitation>>,
    { inviteeId: string }
  > = (props) => {
    const { inviteeId } = props ?? {}

    return userControllerResendInvitation(inviteeId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type UserControllerResendInvitationMutationResult = NonNullable<
  Awaited<ReturnType<typeof userControllerResendInvitation>>
>

export type UserControllerResendInvitationMutationError = ErrorType<unknown>

export const useUserControllerResendInvitation = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof userControllerResendInvitation>>,
      TError,
      { inviteeId: string },
      TContext
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof userControllerResendInvitation>>,
  TError,
  { inviteeId: string },
  TContext
> => {
  const mutationOptions = getUserControllerResendInvitationMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
export const userControllerAcceptInvitation = (
  acceptInvitationDto: AcceptInvitationDto,
  options?: SecondParameter<typeof axiosClient>,
) => {
  return axiosClient<void>(
    {
      url: `https://test-api.detelio.ai/user/invite/accept`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: acceptInvitationDto,
    },
    options,
  )
}

export const getUserControllerAcceptInvitationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userControllerAcceptInvitation>>,
    TError,
    { data: AcceptInvitationDto },
    TContext
  >
  request?: SecondParameter<typeof axiosClient>
}): UseMutationOptions<
  Awaited<ReturnType<typeof userControllerAcceptInvitation>>,
  TError,
  { data: AcceptInvitationDto },
  TContext
> => {
  const mutationKey = ['userControllerAcceptInvitation']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userControllerAcceptInvitation>>,
    { data: AcceptInvitationDto }
  > = (props) => {
    const { data } = props ?? {}

    return userControllerAcceptInvitation(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type UserControllerAcceptInvitationMutationResult = NonNullable<
  Awaited<ReturnType<typeof userControllerAcceptInvitation>>
>
export type UserControllerAcceptInvitationMutationBody = AcceptInvitationDto
export type UserControllerAcceptInvitationMutationError = ErrorType<unknown>

export const useUserControllerAcceptInvitation = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof userControllerAcceptInvitation>>,
      TError,
      { data: AcceptInvitationDto },
      TContext
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof userControllerAcceptInvitation>>,
  TError,
  { data: AcceptInvitationDto },
  TContext
> => {
  const mutationOptions = getUserControllerAcceptInvitationMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
export const userControllerInviteUserV2 = (
  inviteUserDto: InviteUserDto,
  options?: SecondParameter<typeof axiosClient>,
  signal?: AbortSignal,
) => {
  return axiosClient<void>(
    {
      url: `https://test-api.detelio.ai/user/v2/invite`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: inviteUserDto,
      signal,
    },
    options,
  )
}

export const getUserControllerInviteUserV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userControllerInviteUserV2>>,
    TError,
    { data: InviteUserDto },
    TContext
  >
  request?: SecondParameter<typeof axiosClient>
}): UseMutationOptions<
  Awaited<ReturnType<typeof userControllerInviteUserV2>>,
  TError,
  { data: InviteUserDto },
  TContext
> => {
  const mutationKey = ['userControllerInviteUserV2']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userControllerInviteUserV2>>,
    { data: InviteUserDto }
  > = (props) => {
    const { data } = props ?? {}

    return userControllerInviteUserV2(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type UserControllerInviteUserV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof userControllerInviteUserV2>>
>
export type UserControllerInviteUserV2MutationBody = InviteUserDto
export type UserControllerInviteUserV2MutationError = ErrorType<unknown>

export const useUserControllerInviteUserV2 = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof userControllerInviteUserV2>>,
      TError,
      { data: InviteUserDto },
      TContext
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof userControllerInviteUserV2>>,
  TError,
  { data: InviteUserDto },
  TContext
> => {
  const mutationOptions = getUserControllerInviteUserV2MutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
export const userControllerVerifyInvitationV2 = (
  params: UserControllerVerifyInvitationV2Params,
  options?: SecondParameter<typeof axiosClient>,
  signal?: AbortSignal,
) => {
  return axiosClient<VerifyInvitationResponseDto>(
    { url: `https://test-api.detelio.ai/user/v2/invite/verify`, method: 'GET', params, signal },
    options,
  )
}

export const getUserControllerVerifyInvitationV2QueryKey = (
  params?: UserControllerVerifyInvitationV2Params,
) => {
  return [`https://test-api.detelio.ai/user/v2/invite/verify`, ...(params ? [params] : [])] as const
}

export const getUserControllerVerifyInvitationV2QueryOptions = <
  TData = Awaited<ReturnType<typeof userControllerVerifyInvitationV2>>,
  TError = ErrorType<unknown>,
>(
  params: UserControllerVerifyInvitationV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userControllerVerifyInvitationV2>>, TError, TData>
    >
    request?: SecondParameter<typeof axiosClient>
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getUserControllerVerifyInvitationV2QueryKey(params)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof userControllerVerifyInvitationV2>>> = ({ signal }) =>
    userControllerVerifyInvitationV2(params, requestOptions, signal)

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof userControllerVerifyInvitationV2>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type UserControllerVerifyInvitationV2QueryResult = NonNullable<
  Awaited<ReturnType<typeof userControllerVerifyInvitationV2>>
>
export type UserControllerVerifyInvitationV2QueryError = ErrorType<unknown>

export function useUserControllerVerifyInvitationV2<
  TData = Awaited<ReturnType<typeof userControllerVerifyInvitationV2>>,
  TError = ErrorType<unknown>,
>(
  params: UserControllerVerifyInvitationV2Params,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userControllerVerifyInvitationV2>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerVerifyInvitationV2>>,
          TError,
          Awaited<ReturnType<typeof userControllerVerifyInvitationV2>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerVerifyInvitationV2<
  TData = Awaited<ReturnType<typeof userControllerVerifyInvitationV2>>,
  TError = ErrorType<unknown>,
>(
  params: UserControllerVerifyInvitationV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userControllerVerifyInvitationV2>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof userControllerVerifyInvitationV2>>,
          TError,
          Awaited<ReturnType<typeof userControllerVerifyInvitationV2>>
        >,
        'initialData'
      >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useUserControllerVerifyInvitationV2<
  TData = Awaited<ReturnType<typeof userControllerVerifyInvitationV2>>,
  TError = ErrorType<unknown>,
>(
  params: UserControllerVerifyInvitationV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userControllerVerifyInvitationV2>>, TError, TData>
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useUserControllerVerifyInvitationV2<
  TData = Awaited<ReturnType<typeof userControllerVerifyInvitationV2>>,
  TError = ErrorType<unknown>,
>(
  params: UserControllerVerifyInvitationV2Params,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof userControllerVerifyInvitationV2>>, TError, TData>
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getUserControllerVerifyInvitationV2QueryOptions(params, options)

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>
  }

  query.queryKey = queryOptions.queryKey

  return query
}

export const userControllerAcceptInvitationV2 = (
  acceptInvitationDto: AcceptInvitationDto,
  options?: SecondParameter<typeof axiosClient>,
) => {
  return axiosClient<void>(
    {
      url: `https://test-api.detelio.ai/user/v2/invite/accept`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: acceptInvitationDto,
    },
    options,
  )
}

export const getUserControllerAcceptInvitationV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userControllerAcceptInvitationV2>>,
    TError,
    { data: AcceptInvitationDto },
    TContext
  >
  request?: SecondParameter<typeof axiosClient>
}): UseMutationOptions<
  Awaited<ReturnType<typeof userControllerAcceptInvitationV2>>,
  TError,
  { data: AcceptInvitationDto },
  TContext
> => {
  const mutationKey = ['userControllerAcceptInvitationV2']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userControllerAcceptInvitationV2>>,
    { data: AcceptInvitationDto }
  > = (props) => {
    const { data } = props ?? {}

    return userControllerAcceptInvitationV2(data, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type UserControllerAcceptInvitationV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof userControllerAcceptInvitationV2>>
>
export type UserControllerAcceptInvitationV2MutationBody = AcceptInvitationDto
export type UserControllerAcceptInvitationV2MutationError = ErrorType<unknown>

export const useUserControllerAcceptInvitationV2 = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof userControllerAcceptInvitationV2>>,
      TError,
      { data: AcceptInvitationDto },
      TContext
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof userControllerAcceptInvitationV2>>,
  TError,
  { data: AcceptInvitationDto },
  TContext
> => {
  const mutationOptions = getUserControllerAcceptInvitationV2MutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
export const userControllerAcceptExistingUserInvitation = (
  params: UserControllerAcceptExistingUserInvitationParams,
  options?: SecondParameter<typeof axiosClient>,
) => {
  return axiosClient<void>(
    { url: `https://test-api.detelio.ai/user/v2/invite/accept-existing`, method: 'PATCH', params },
    options,
  )
}

export const getUserControllerAcceptExistingUserInvitationMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userControllerAcceptExistingUserInvitation>>,
    TError,
    { params: UserControllerAcceptExistingUserInvitationParams },
    TContext
  >
  request?: SecondParameter<typeof axiosClient>
}): UseMutationOptions<
  Awaited<ReturnType<typeof userControllerAcceptExistingUserInvitation>>,
  TError,
  { params: UserControllerAcceptExistingUserInvitationParams },
  TContext
> => {
  const mutationKey = ['userControllerAcceptExistingUserInvitation']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userControllerAcceptExistingUserInvitation>>,
    { params: UserControllerAcceptExistingUserInvitationParams }
  > = (props) => {
    const { params } = props ?? {}

    return userControllerAcceptExistingUserInvitation(params, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type UserControllerAcceptExistingUserInvitationMutationResult = NonNullable<
  Awaited<ReturnType<typeof userControllerAcceptExistingUserInvitation>>
>

export type UserControllerAcceptExistingUserInvitationMutationError = ErrorType<unknown>

export const useUserControllerAcceptExistingUserInvitation = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof userControllerAcceptExistingUserInvitation>>,
      TError,
      { params: UserControllerAcceptExistingUserInvitationParams },
      TContext
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof userControllerAcceptExistingUserInvitation>>,
  TError,
  { params: UserControllerAcceptExistingUserInvitationParams },
  TContext
> => {
  const mutationOptions = getUserControllerAcceptExistingUserInvitationMutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
export const userControllerResendInvitationV2 = (
  inviteeId: string,
  options?: SecondParameter<typeof axiosClient>,
) => {
  return axiosClient<void>(
    { url: `https://test-api.detelio.ai/user/v2/invite/resend/${inviteeId}`, method: 'PATCH' },
    options,
  )
}

export const getUserControllerResendInvitationV2MutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof userControllerResendInvitationV2>>,
    TError,
    { inviteeId: string },
    TContext
  >
  request?: SecondParameter<typeof axiosClient>
}): UseMutationOptions<
  Awaited<ReturnType<typeof userControllerResendInvitationV2>>,
  TError,
  { inviteeId: string },
  TContext
> => {
  const mutationKey = ['userControllerResendInvitationV2']
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined }

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof userControllerResendInvitationV2>>,
    { inviteeId: string }
  > = (props) => {
    const { inviteeId } = props ?? {}

    return userControllerResendInvitationV2(inviteeId, requestOptions)
  }

  return { mutationFn, ...mutationOptions }
}

export type UserControllerResendInvitationV2MutationResult = NonNullable<
  Awaited<ReturnType<typeof userControllerResendInvitationV2>>
>

export type UserControllerResendInvitationV2MutationError = ErrorType<unknown>

export const useUserControllerResendInvitationV2 = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof userControllerResendInvitationV2>>,
      TError,
      { inviteeId: string },
      TContext
    >
    request?: SecondParameter<typeof axiosClient>
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof userControllerResendInvitationV2>>,
  TError,
  { inviteeId: string },
  TContext
> => {
  const mutationOptions = getUserControllerResendInvitationV2MutationOptions(options)

  return useMutation(mutationOptions, queryClient)
}
